import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ButtonComponent } from "../button/button.component";
import { NgClass } from "@angular/common";

@Component({
    selector: "rask-flap-button",
    templateUrl: "./flap-button.component.html",
    styleUrls: ["./flap-button.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class FlapButtonComponent extends ButtonComponent implements OnInit {

    @Input() buttonState = false;

    ngOnInit(): void {
        super.ngOnInit();
    }

}
